import buttonColumn from "@root/tabulator/Services/buttonColumn";
import { stopPropagation } from "@root/tabulator/Services/stopPropagation";

export default function resetPassword(columns, { route }, api) {
  columns.push(buttonColumn(
      'resetPassword',
      'lock',
      (e, cell) => {
        stopPropagation(e);

        const { id, name, email, user__id } = cell.getRow().getData();

        if (!user__id || !email) return;

        if (confirm(`Send password reset email to ${name} ${email ? `(${email})` : ''}?`)) {
          api.post(route, { id });
        }

      }, 'Send reset password email',
      (cell) => {
        const { user__id, email } = cell.getRow().getData();

        return user__id && email;
      }));
};
